import styled from "styled-components";
import { statPanelSurface } from "./panelStyles";

/** Shared frame for time-series and ranking charts. */
export const ChartCardPanel = styled.section`
	${statPanelSurface}
	color: #344054;
	.header { display: flex; align-items: center; justify-content: space-between; gap: 12px; min-height: 52px; box-sizing: border-box; padding: 10px 16px; border-bottom: 1px solid #edf0f5; }
	h3 { display: flex; align-items: center; gap: 12px; min-width: 0; margin: 0; font-size: 14px; font-weight: 600; line-height: 1.5; overflow-wrap: anywhere; }
	h3 svg { flex-shrink: 0; color: #167ca6; }
	h3 span { min-width: 0; }
	.body { min-width: 0; padding: 12px 16px; }
`;
